const observeVisibility = (element: HTMLElement, callback: IntersectionObserverCallback): IntersectionObserver => {
  const observer = new IntersectionObserver(
    (entries: IntersectionObserverEntry[]): void => {
      entries.forEach((entry: IntersectionObserverEntry): void => {
        callback(entry.isIntersecting)
      })
    },
    {
      threshold: 0.1
    }
  )

  observer.observe(element)
  return observer
}
export const useSidebarBottom = (sidebarSelector: string = '#sidebar-bottom', componentSelector: string = '#banner'): void => {
  const sidebarElement: HTMLElement | null = document.querySelector(sidebarSelector)
  const componentElement: HTMLElement | null = document.querySelector(componentSelector)
  if (componentElement && sidebarElement) {
    observeVisibility(componentElement, (isVisible: IntersectionObserverEntry[]): void => {
      if (isVisible) {
        sidebarElement.style.bottom = '-100px'
      } else {
        sidebarElement.style.bottom = '0'
      }
    })
  }
}
